import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters76mmMidrailTiltControlRevealFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      id="prefix__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters76"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={41.39}
          y1={497.01}
          x2={41.39}
          y2={472.12}
          gradientTransform="translate(.5 -431.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={7082.51}
          y1={497.01}
          x2={7082.51}
          y2={472.12}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={41.39}
          y1={522.08}
          x2={41.39}
          y2={497.2}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={7082.51}
          y1={522.08}
          x2={7082.51}
          y2={497.2}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={41.39}
          y1={547.33}
          x2={41.39}
          y2={522.43}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={7082.51}
          y1={547.33}
          x2={7082.51}
          y2={522.43}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={41.39}
          y1={572.57}
          x2={41.39}
          y2={547.69}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={7082.51}
          y1={572.57}
          x2={7082.51}
          y2={547.69}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={41.39}
          y1={597.8}
          x2={41.39}
          y2={572.91}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={7082.51}
          y1={597.8}
          x2={7082.51}
          y2={572.91}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={41.39}
          y1={623.05}
          x2={41.39}
          y2={598.17}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={7082.51}
          y1={623.05}
          x2={7082.51}
          y2={598.17}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={41.39}
          y1={675.35}
          x2={41.39}
          y2={650.47}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7082.51}
          y1={675.35}
          x2={7082.51}
          y2={650.47}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={41.39}
          y1={700.61}
          x2={41.39}
          y2={675.73}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7082.51}
          y1={700.61}
          x2={7082.51}
          y2={675.73}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={41.39}
          y1={725.87}
          x2={41.39}
          y2={700.99}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7082.51}
          y1={725.87}
          x2={7082.51}
          y2={700.99}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={41.39}
          y1={751.09}
          x2={41.39}
          y2={726.2}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7082.51}
          y1={751.09}
          x2={7082.51}
          y2={726.2}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={41.39}
          y1={776.34}
          x2={41.39}
          y2={751.46}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7082.51}
          y1={776.34}
          x2={7082.51}
          y2={751.46}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={41.39}
          y1={801.58}
          x2={41.39}
          y2={776.7}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7082.51}
          y1={801.58}
          x2={7082.51}
          y2={776.7}
          gradientTransform="matrix(-1 0 0 1 7339.59 -431.5)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={350.41}
          y1={487.35}
          x2={350.41}
          y2={483.2}
          gradientTransform="translate(.5 -431.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={461.54}
          y1={487.35}
          x2={461.54}
          y2={483.2}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={350.41}
          y1={512}
          x2={350.41}
          y2={507.85}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={461.54}
          y1={512}
          x2={461.54}
          y2={507.85}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={461.54}
          y1={536.66}
          x2={461.54}
          y2={532.51}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={350.41}
          y1={536.66}
          x2={350.41}
          y2={532.51}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-31"
          x1={461.54}
          y1={561.31}
          x2={461.54}
          y2={557.16}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-32"
          x1={350.41}
          y1={561.31}
          x2={350.41}
          y2={557.16}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-33"
          x1={350.41}
          y1={585.96}
          x2={350.41}
          y2={581.81}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-34"
          x1={461.54}
          y1={585.96}
          x2={461.54}
          y2={581.81}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-35"
          x1={461.54}
          y1={610.62}
          x2={461.54}
          y2={606.47}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-36"
          x1={350.41}
          y1={610.62}
          x2={350.41}
          y2={606.47}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-37"
          x1={350.41}
          y1={667.06}
          x2={350.41}
          y2={662.91}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-38"
          x1={461.54}
          y1={667.06}
          x2={461.54}
          y2={662.91}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-39"
          x1={350.41}
          y1={691.71}
          x2={350.41}
          y2={687.56}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-40"
          x1={461.54}
          y1={691.71}
          x2={461.54}
          y2={687.56}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-41"
          x1={350.41}
          y1={716.37}
          x2={350.41}
          y2={712.21}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-42"
          x1={461.54}
          y1={716.37}
          x2={461.54}
          y2={712.21}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-43"
          x1={350.41}
          y1={741.02}
          x2={350.41}
          y2={736.87}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-44"
          x1={461.54}
          y1={741.02}
          x2={461.54}
          y2={736.87}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-45"
          x1={350.41}
          y1={765.67}
          x2={350.41}
          y2={761.52}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-46"
          x1={461.54}
          y1={765.67}
          x2={461.54}
          y2={761.52}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-47"
          x1={350.41}
          y1={790.33}
          x2={350.41}
          y2={786.18}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-48"
          x1={461.54}
          y1={790.33}
          x2={461.54}
          y2={786.18}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <style>
          {
            '.prefix__cls-1{fill:#f1f1f1}.prefix__cls-2,.prefix__cls-43,.prefix__cls-57,.prefix__cls-6{opacity:.15}.prefix__cls-3,.prefix__cls-6{fill:#4d4d4d}.prefix__cls-4{opacity:.2}.prefix__cls-5{fill:#333}.prefix__cls-43,.prefix__cls-57,.prefix__cls-6{isolation:isolate}.prefix__cls-43,.prefix__cls-57{fill:none;stroke:#4d4d4d;stroke-miterlimit:10}.prefix__cls-43{stroke-width:.64px}.prefix__cls-57{stroke-width:.99px}.prefix__cls-58{fill:gray;opacity:.2}'
          }
        </style>
      </defs>
      <path
        fill="url(#shutters76)"
        d="M515.12 13.24h-502v384h529.52v-384zM297.83 55.87H404v20.47H297.83zm0 24.6H404v20.47H297.83zm0 24.7H404v20.47H297.83zm0 24.6H404v20.56H297.83zm0 24.69H404v20.47H297.83zm0 24.7H404v12.58H297.83zm0 39.62H404v12.59H297.83zm0 16.81H404v20.47H297.83zm0 24.6H404v20.47H297.83zm0 24.7H404v20.47H297.83zm0 24.6H404V330H297.83zm0 24.69H404v20.47H297.83zm217.29 36.06H297.83v-11.46H404v11.36h5v-11.36h106.12zm0-15.59H409v-20.47h106.12zm0-24.6H409v-20.47h106.12zm0-24.69H409v-20.47h106.12zm0-24.6H409v-20.57h106.12zm0-24.7H409v-20.47h106.12zm0-24.69H409v-12.59h106.12zm0-39.63H409v-12.58h106.12zm0-16.81H409V154.5h106.12zm0-24.6H409v-20.47h106.12zm0-24.69H409v-20.47h106.12zm0-24.6H409V80.5h106.12zm0-24.7H409V55.87h106.12zm0-24.6H409V40.29h-5v11.45H297.83V40.29h217.29z"
      />
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M41.08 397.75H12.6v-385h28.48zm-27.52-.94h26.56V13.71H13.56z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M258.37 40.76H40.12v-28h218.25zm-217.29-.94h216.33V13.71H41.08z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M258.37 219.25H40.12v-28h218.25zm-217.29-.94h216.33v-26.1H41.08z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M515.6 219.25H297.35v-28H515.6zm-217.29-.94h216.33v-26.1H298.31z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M258.37 397.75H40.12v-28h218.25zm-217.29-.94h216.33v-26.1H41.08z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M515.6 40.76H297.35v-28H515.6zm-217.29-.94h216.33V13.71H298.31z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M515.6 397.75H297.35v-28H515.6zm-217.29-.94h216.33v-26.1H298.31z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M543.12 397.75h-28.48v-385h28.48zm-27.52-.94h26.56V13.71H515.6z"
        />
      </g>
      <g className="prefix__cls-2">
        <path
          className="prefix__cls-3"
          d="M278.24 397.75h-20.83v-385h20.83zm-20-.84h19.26V13.62h-19.23z"
        />
        <path
          className="prefix__cls-3"
          d="M298.21 397.75h-20.83v-385h20.83zm-20-.84h19.29V13.62h-19.26z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M13.08 72.77h2.48v35.77h-2.48zM13.08 301.98h2.48v35.77h-2.48z"
        />
      </g>
      <path
        className="prefix__cls-6"
        d="M40.22 39.82v152.39h218.15V39.82zM257.5 65.08H151.73v.84h105.68v24.41H151.73v.85h105.68v24.41H151.73v.85h105.68v24.41H151.73v.84h105.68v24.42H151.73v.89h105.68v24.42H151.73v.28h-5v-.28H41V167h105.67v-.84H41v-24.47h105.67v-.84H41v-24.41h105.67v-.85H41V91.18h105.67v-.85H41V65.92h105.67v-.84H41V40.66h105.67v-.37h5v.37h105.65v24.42z"
      />
      <path
        fill="url(#prefix__linear-gradient)"
        d="M42.7 40.66h-1.62v24.89l1.62-24.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M256.27 40.66h1.62v24.89l-1.62-24.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M42.7 65.73h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M256.27 65.73h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M42.7 90.9h-1.62v24.97L42.7 90.9z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M256.27 90.9h1.62v24.97l-1.62-24.97z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M42.7 116.16h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M256.27 116.16h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M42.7 141.41h-1.62v24.89l1.62-24.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M256.27 141.41h1.62v24.89l-1.62-24.89z"
      />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M42.7 166.67h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M256.27 166.67h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M42.7 218.97h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M256.27 218.97h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M42.7 244.23h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M256.27 244.23h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M42.7 269.49h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M256.27 269.49h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M42.7 294.65h-1.62v24.98l1.62-24.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M256.27 294.65h1.62v24.98l-1.62-24.98z"
      />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M42.7 319.91h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M256.27 319.91h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M42.7 345.17h-1.62v24.88l1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M256.27 345.17h1.62v24.88l-1.62-24.88z"
      />
      <path
        fill="url(#prefix__linear-gradient-25)"
        d="M297.83 51.74h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-26)"
        d="M408.96 51.74h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-27)"
        d="M297.83 76.34h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-28)"
        d="M408.96 76.34h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-29)"
        d="M408.96 101.04h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-30)"
        d="M297.83 101.04h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-31)"
        d="M408.96 125.64h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-32)"
        d="M297.83 125.64h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-33)"
        d="M297.83 150.33h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-34)"
        d="M408.96 150.33h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-35)"
        d="M408.96 174.93h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-36)"
        d="M297.83 174.93h106.16v4.13H297.83z"
      />
      <path className="prefix__cls-43" d="M403.99 40.29h4.97v151.27h-4.97z" />
      <path
        fill="url(#prefix__linear-gradient-37)"
        d="M297.83 231.37h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-38)"
        d="M408.96 231.37h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-39)"
        d="M297.83 256.06h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-40)"
        d="M408.96 256.06h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-41)"
        d="M297.83 280.76h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-42)"
        d="M408.96 280.76h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-43)"
        d="M297.83 305.36h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-44)"
        d="M408.96 305.36h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-45)"
        d="M297.83 330.05h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-46)"
        d="M408.96 330.05h106.16v4.13H408.96z"
      />
      <path
        fill="url(#prefix__linear-gradient-47)"
        d="M297.83 354.65h106.16v4.13H297.83z"
      />
      <path
        fill="url(#prefix__linear-gradient-48)"
        d="M408.96 354.65h106.16v4.13H408.96z"
      />
      <path className="prefix__cls-43" d="M403.99 218.88h4.97v151.27h-4.97z" />
      <path
        className="prefix__cls-6"
        d="M40.22 218.41V370.8h218.15V218.31H40.22zm217.28 25.26H151.73v.83h105.68v24.41H151.73v.85h105.68v24.41H151.73v.83h105.68v24.41H151.73v.85h105.68v24.44H151.73v.8h105.68v24.42H151.73v.37h-5v-.37H41V345.5h105.67v-.84H41v-24.37h105.67v-.94H41v-24.42h105.67v-.84H41v-24.41h105.67v-.85H41v-24.41h105.67v-.85H41v-24.41h105.67v-.28h5v.28h105.65v24.51z"
      />
      <path
        className="prefix__cls-43"
        d="M146.76 218.88h4.97v151.27h-4.97zM146.76 40.29h4.97v151.27h-4.97z"
      />
      <path
        style={{
          isolation: 'isolate',
        }}
        fill="none"
        stroke="#4d4d4d"
        strokeMiterlimit={10}
        opacity={0.2}
        d="M.5.5h555.2v410H.5z"
      />
      <path
        fill="url(#shutters76)"
        d="M.5.5v410h555.2V.5zm542 396.75H13.75V13.75H542.5z"
      />
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-3"
          d="M554.7 1.5v408H1.5V1.5h553.2M12.75 398.25H543.5V12.75H12.75v385.5M555.7.5H.5v410h555.2zM13.75 397.25V13.75H542.5v383.5z"
        />
      </g>
      <path
        className="prefix__cls-57"
        d="M406.4 209.82a4.46 4.46 0 014.46 4.46v4.47H402v-4.47a4.46 4.46 0 014.46-4.46z"
      />
      <path className="prefix__cls-1" d="M404.3 217.59h4.33v2.6h-4.33z" />
      <path
        className="prefix__cls-57"
        d="M409.11 218.52v-3.18h-5.28v3.18M406.4 31.27a4.48 4.48 0 014.46 4.47v4.46H402v-4.46a4.48 4.48 0 014.46-4.47z"
      />
      <path className="prefix__cls-1" d="M404.31 39.04h4.33v2.6h-4.33z" />
      <path
        className="prefix__cls-57"
        d="M409.12 39.97v-3.18h-5.29v3.18M149.17 31.24a4.46 4.46 0 014.46 4.46v4.46h-8.91V35.7a4.46 4.46 0 014.46-4.46z"
      />
      <path className="prefix__cls-1" d="M147.08 39.01h4.33v2.6h-4.33z" />
      <path
        className="prefix__cls-57"
        d="M151.89 39.93v-3.18h-5.29v3.18M149.17 209.84a4.46 4.46 0 014.46 4.46v4.46h-8.91v-4.46a4.46 4.46 0 014.46-4.46z"
      />
      <path className="prefix__cls-1" d="M147.08 217.61h4.33v2.6h-4.33z" />
      <path className="prefix__cls-57" d="M151.89 218.53v-3.18h-5.29v3.18" />
      <path
        className="prefix__cls-58"
        d="M551.34 4.88l3.37-3.39v407.99l-3.37-3.36V4.88zM4.88 4.88L1.51 1.49v407.99l3.37-3.36V4.88zM4.87 406.14l-3.38 3.37h553.22l-3.36-3.37H4.87z"
      />
      <path
        className="prefix__cls-58"
        d="M4.87 4.86L1.49 1.49h553.22l-3.36 3.37H4.87z"
      />
    </svg>
  );
};
